import React from "react";
import "./Loading.css";

class Loading extends React.Component {
  componentDidMount() {
    let backdrop = document.querySelector("#backdrop");
    backdrop.style.cssText =
      "position:fixed;z-index:5;background:#000000c2;height:100vh;width:100vw;";
  }
  componentWillUnmount() {
    let backdrop = document.querySelector("#backdrop");
    backdrop.style = "none";
  }
  render() {
    return (
      <div className="loading">
        <div className="hex hex1"></div>
        <div className="hex hex2"></div>
        <div className="hex hex3"></div>
        <div className="hex hex4"></div>
        <div className="hex hex5"></div>
        <div className="hex hex6"></div>
        <div className="hex hex7"></div>
      </div>
    );
  }
}

export default Loading;
